enum WizardEvents {
  WizardClick = 'wizard_tap',
}

export default WizardEvents
